import { render } from "./Shopify.vue?vue&type=template&id=dfce2dac&scoped=true"
import script from "./Shopify.vue?vue&type=script&lang=js"
export * from "./Shopify.vue?vue&type=script&lang=js"

import "./Shopify.vue?vue&type=style&index=0&id=dfce2dac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfce2dac"]])

export default __exports__